import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionScheduledEmail } from '../model';

const SCHEDULED_EMAILS_URL = '/collections/scheduled_emails';

export function useCollectionScheduledEmails(location: string, enabled = true) {
  return useGet<CollectionScheduledEmail[]>({
    url: SCHEDULED_EMAILS_URL,
    params: { location },
    enabled: !!location && enabled,
  });
}
